import { render, staticRenderFns } from "./dynamic-filter-base.vue?vue&type=template&id=0cfcffcb&scoped=true&lang=pug"
import script from "./dynamic-filter-base.vue?vue&type=script&lang=js"
export * from "./dynamic-filter-base.vue?vue&type=script&lang=js"
import style0 from "./dynamic-filter-base.vue?vue&type=style&index=0&id=0cfcffcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcffcb",
  null
  
)

export default component.exports